import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;
const api = axios.create({ baseURL: BASE, withCredentials: true, timeout: 20000, headers: { 'X-Requested-With': 'XMLHttpRequest' } });

export const exchangeSession = (session_id) => api.post('/google/session', { session_id }).then(r => r.data);
export const authMe = () => api.get('/me').then(r => r.data);
export const authLogout = () => api.post('/logout').then(r => r.data);
export const myApplications = () => api.get('/me/applications').then(r => r.data);

export const registerEmail = (name, email, password) => api.post('/register', { name, email, password }).then(r => r.data);
export const loginEmail = (email, password) => api.post('/login', { email, password }).then(r => r.data);
export const verifyEmail = (token) => api.post('/verify-email', { token }).then(r => r.data);
export const resendVerification = (email) => api.post('/resend-verification', { email }).then(r => r.data);
export const forgotPassword = (email) => api.post('/forgot-password', { email }).then(r => r.data);
export const resetPassword = (token, password) => api.post('/reset-password', { token, password }).then(r => r.data);
export const setPassword = (password, current_password) => api.post('/set-password', { password, current_password }).then(r => r.data);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = (returnPath = '/account') => {
  const redirectUrl = window.location.origin + returnPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
